import React from 'react';

interface PropTypes {
  secondaryText: JSX.Element;
}

export function SecondaryText(props: PropTypes) {
  return (
    <div className='row mt-4 justify-content-center text-center'>
      <span>{props.secondaryText}</span>
    </div>
  );
}
